/**
 * Created by Jerker Nord on 2021-09-03.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TrueGrit} from "../TrueGrit";
import {TrueGritStatics} from "../TrueGritStatics";
import {gsap} from "gsap";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {MathUtils} from "../utils/MathUtils";
import {BetWayWinData} from "../server/TrueGritData";

export class TrueGritInitialWinOnTopView extends PIXI.Container implements StageLayer {

    private _explosions:TimelineSprite[][];
    private _smoke01:TimelineSprite[][];
    private _smoke02:TimelineSprite[][];
    private _waysContainer:PIXI.Container;

    private _m0HitAmount: PIXI.BitmapText;
    private _m0HitText: PIXI.Sprite;
    private _m0HitTimesX: PIXI.BitmapText;
    private _m0HitContainer: PIXI.Container;

    private static EXPLOSION_OFFSET:PIXI.Point = new PIXI.Point(84, 85);
    private static TOP_REEL_EXPLOSION_OFFSET:PIXI.Point = new PIXI.Point(84, -28);
    private static SMOKE_OFFSET:PIXI.Point = new PIXI.Point(60, 20);
    private static TOP_REEL_SMOKE_OFFSET:PIXI.Point = new PIXI.Point(60, -100);

    constructor() {
        super();
        this.name = "TrueGritInitialWinOnTopView";
        this.init();
    }

    private init() {
        this._explosions = [];
        let tempExplosionAnimation:TimelineSprite;
        let reelSymHeigt:number;
        for(let i:number = 0; i < 6; i++) {
            const subSymbolExplosions:TimelineSprite[] = [];
            reelSymHeigt = 4;
            if(i > 0 && i < 4) {
                reelSymHeigt = 5;
            }
            for(let j:number = 0; j < reelSymHeigt; j++) {
                tempExplosionAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/winExplosion/winexplosion_"));
                tempExplosionAnimation.anchor.set(0.5, 0.5);
                tempExplosionAnimation.position = TrueGritInitialWinOnTopView.EXPLOSION_OFFSET;
                if(i > 0 && i < 4) {
                    tempExplosionAnimation.position = TrueGritInitialWinOnTopView.TOP_REEL_EXPLOSION_OFFSET;
                }
                tempExplosionAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempExplosionAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempExplosionAnimation.visible = false;
                this.addChild(tempExplosionAnimation);
                subSymbolExplosions.push(tempExplosionAnimation);
            }
            this._explosions.push(subSymbolExplosions);
        }

        this._smoke01 = [];
        let tempSmokeAnimation:TimelineSprite;
        for(let i:number = 0; i < 6; i++) {
            const subSmoke:TimelineSprite[] = [];
            reelSymHeigt = 4;
            if(i > 0 && i < 4) {
                reelSymHeigt = 5;
            }
            for(let j:number = 0; j < reelSymHeigt; j++) {
                tempSmokeAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/winBulletHole/winbullethole_"));
                tempSmokeAnimation.anchor.set(0.5, 0.5);
                tempSmokeAnimation.position = TrueGritInitialWinOnTopView.SMOKE_OFFSET;
                if(i > 0 && i < 4) {
                    tempSmokeAnimation.position = TrueGritInitialWinOnTopView.TOP_REEL_SMOKE_OFFSET;
                }
                tempSmokeAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSmokeAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSmokeAnimation.visible = false;
                /*
                if(i % 2) {
                    tempSmokeAnimation.scale.x = -1;
                    tempSmokeAnimation.position.x += 20;
                }

                 */
                this.addChild(tempSmokeAnimation);
                subSmoke.push(tempSmokeAnimation);
            }
            this._smoke01.push(subSmoke);
        }

        this._smoke02 = [];
        for(let i:number = 0; i < 6; i++) {
            const subSmoke:TimelineSprite[] = [];
            reelSymHeigt = 4;
            if(i > 0 && i < 4) {
                reelSymHeigt = 5;
            }
            for(let j:number = 0; j < reelSymHeigt; j++) {
                tempSmokeAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/winBulletHole/winbullethole2_"));
                tempSmokeAnimation.anchor.set(0.5, 0.5);
                tempSmokeAnimation.position = TrueGritInitialWinOnTopView.SMOKE_OFFSET;
                if(i > 0 && i < 4) {
                    tempSmokeAnimation.position = TrueGritInitialWinOnTopView.TOP_REEL_SMOKE_OFFSET;
                }
                tempSmokeAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSmokeAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSmokeAnimation.visible = false;
                /*
                if(i % 2) {
                    tempSmokeAnimation.scale.x = -1;
                    tempSmokeAnimation.position.x += 20;
                }

                 */
                this.addChild(tempSmokeAnimation);
                subSmoke.push(tempSmokeAnimation);
            }
            this._smoke02.push(subSmoke);
        }

        this._m0HitContainer = new PIXI.Container();
        this._m0HitContainer.position.set(360, 240);

        this._m0HitText = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("text/gritHit")[0]);
        this._m0HitText.visible = false;
        this._m0HitText.y = 5;

        this._m0HitTimesX = new PIXI.BitmapText("", {
            fontName: TrueGritGameAssets.BITMAP_FONT_NUMBERS_WAYS_WON,
            fontSize: 70,
            tint: 0xffffff
        });
        this._m0HitTimesX.visible = false;

        this._m0HitContainer.addChild(this._m0HitText, this._m0HitTimesX);

        this._m0HitAmount = new PIXI.BitmapText("", {
            fontName: TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize: 200,
            tint: 0xffffff
        });
        this._m0HitAmount.maxWidth = 680;
        this._m0HitAmount.anchor = new PIXI.Point(0, 0.5);
        this._m0HitAmount.visible = false;

        this.addChild(this._m0HitContainer, this._m0HitAmount);

        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public getExplosionAnimation(reel:number, row:number):gsap.core.Timeline {
        if(reel == 0 || reel > 3) {
            row--;
        }
        return this._explosions[reel][row].getAnimationAutoShowHide();
    }

    public getSmokeAnimation(reel:number, row:number):gsap.core.Timeline {
        if(reel == 0 || reel > 3) {
            row--;
        }
        let tempSmoke:TimelineSprite;
        let randomValue1: number = MathUtils.randomIntFromInterval(1, 2);
        if(randomValue1 == 1) {
            tempSmoke = this._smoke01[reel][row];
        } else {
            tempSmoke = this._smoke02[reel][row];
        }
        let randomValue: number = MathUtils.randomIntFromInterval(1, 2),
            xOffset: number = 0,
            yOffset: number = 0;
        const scaleX: number = (randomValue === 1 ? -1 : 1);
        if(randomValue == 1) {
            if (randomValue1 !== 1) {
                yOffset = 5;
            }
            tempSmoke.scale.x = scaleX;
        } else {
            tempSmoke.scale.x = scaleX;
        }
        // smoke if 1
        if (randomValue1 === 1 && scaleX === -1) {
            xOffset = 20;
        }
        // smoke is 2
        else if (randomValue1 !== 1) {
            xOffset = 8;
        }

        // #105
        TrueGrit.reelBackgroundView.turnOnBulletHole(reel, row, scaleX, xOffset, yOffset);

        return tempSmoke.getAnimationAutoShowHide();
    }

    public getRoundWinAnimation(betWayWins: BetWayWinData[]):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            container: PIXI.Container = new PIXI.Container();

        container.position.set(374, (360 - this.position.y));
        container.alpha = 0;

        betWayWins.forEach((betWay: BetWayWinData, idx: number) => {
            const winAmount: PIXI.BitmapText = new PIXI.BitmapText(betWay.multipliedAmount.toFixed(2), {
                    fontName: TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
                    fontSize: 70
                }),
                waysContainer: PIXI.Container = new PIXI.Container(),
                waysAmount: PIXI.BitmapText = new PIXI.BitmapText(betWay.numberOfCombinations + "", {
                    fontName: TrueGritGameAssets.BITMAP_FONT_NUMBERS_WAYS_WON,
                    fontSize: 44
                }),
                waysText: PIXI.Sprite = new PIXI.Sprite((betWay.numberOfCombinations === 1) ? TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAY_WON_TEXT)[0] : TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAYS_WON_TEXT)[0]);

            waysText.x = (waysAmount.width);
            waysText.scale.set(0.75);

            winAmount.y = (idx * 30) + (idx * 70);
            winAmount.pivot.set(winAmount.width / 2, winAmount.height / 2);

            waysText.y = 5;
            waysContainer.y = (winAmount.y + 5);

            waysContainer.addChild(waysText, waysAmount);
            waysContainer.pivot.set(waysContainer.width / 2, 0);

            container.addChild(waysContainer, winAmount);
        });

        if (betWayWins.length > 5) {
            container.scale.set(0.6);
        }
        container.y -= (container.height / 4);

        this.addChild(container, this._m0HitContainer, this._m0HitAmount);

        tl.to(container, {
            duration: 0.1,
            alpha: 1
        });
        tl.to(container, {
            duration: 0.5,
            y: "-=50"
        });
        tl.to(container, {
            duration: 0.1,
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            this.removeChild(container);
        });

        return tl;
    }

    public getM0RoundWinAnimation(winAmount:number, gritHitX: number): gsap.core.Timeline {
        this._m0HitAmount.alpha = 0;
        this._m0HitAmount.visible = true;
        this._m0HitAmount.fontSize = 200;
        this._m0HitAmount.text = winAmount.toFixed(2);
        // to keep it inside the visible area
        while (this._m0HitAmount.textWidth > this._m0HitAmount.maxWidth) {
            this._m0HitAmount.fontSize--;
        }
        this._m0HitAmount.x = (360 - this._m0HitAmount.width / 2);
        this._m0HitAmount.y = 190;

        this._m0HitTimesX.text = gritHitX.toFixed(0) + "x"; // #483 -> toFixed(0), so that trailing digits are removed and as per payouts it will be a whole number/
        this._m0HitTimesX.alpha = 0;
        this._m0HitTimesX.visible = true;

        this._m0HitText.alpha = 0;
        this._m0HitText.visible = true;
        this._m0HitText.x = (this._m0HitTimesX.x + this._m0HitTimesX.width + 10);

        this._m0HitContainer.x = (360 - this._m0HitContainer.width / 2);

        // #476
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to([this._m0HitAmount, this._m0HitText, this._m0HitTimesX], {duration : 0.1, alpha : 1});
        tl.to(this, {
            duration: 2
        });
        tl.to([this._m0HitAmount, this._m0HitText, this._m0HitTimesX], {duration : 0.3, alpha : 0, onComplete: () => {
            this._m0HitAmount.visible = false;
            this._m0HitText.visible = false;
            this._m0HitTimesX.visible = false;
        }});

        return tl;
    }
}